import { useEffect, useMemo } from "react";
import { debounce } from "services";

export const useInfiniteScroll = ({
  disabled,
  onReachBottom,
}: {
  disabled: boolean;
  onReachBottom: () => void;
}) => {
  const handler = useMemo(
    () =>
      debounce(() => {
        if (disabled) return;

        const scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop;

        const scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight;

        const clientHeight =
          document.documentElement.clientHeight || window.innerHeight;

        if (scrollTop + clientHeight >= scrollHeight - 200) {
          onReachBottom();
        }
      }, 300),
    [disabled, onReachBottom],
  );

  useEffect(() => {
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, [handler]);
};
